import React from "react";
import {useDispatch, useSelector} from 'react-redux';
// nodejs library that concatenates classes
import classNames from "classnames";
// react components for routing our app without refresh
import { Link } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import Header from "components/Header/Header.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Parallax from "components/Parallax/Parallax.js";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.js";
import AdminSection from "./Sections/SectionAdmin";
import styles from "assets/jss/material-kit-react/views/components.js";
import { useHistory } from "react-router-dom";

const firebase = require('./../../configFirebase')


const useStyles = makeStyles(styles);

export default function Components(props) {
  const classes = useStyles();
  const history = useHistory()
  const user = useSelector(store => store.main.user);
  const logged = useSelector(store => store.main.state);
  const [logged2, setlogged2] = React.useState(false);
 
 

  if(!logged){
    history.push('login');
  }
  const { ...rest } = props;
  return (
    <div>
      <Header
        brand="Material Kit React"
        rightLinks={<div />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color:"white"
        }}
        {...rest}
      />
      <Parallax image={require("assets/img/bg4.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>Admin Portal </h1>
                <h3 onClick={()=>{history.push('/')}} className={classes.subtitle}>
                   Welcome to Admin Portal  {user.name +' '+ user.surname} 
                </h3>
               
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>

      <div className={classNames(classes.main, classes.mainRaised)}>
       {logged && <AdminSection />}
       
      </div>
    </div>
  );
}
